import { LucideIcon } from "lucide-react";
import { ElementType, isValidElement } from "react";

export const renderIcon = (icon: LucideIcon | JSX.Element | undefined) => {
  if (!icon)
    return null;

  if (isValidElement(icon))
    return icon;

  const Icon = icon as ElementType;

  return <Icon size={16} strokeWidth={1.5} />;
};
